import React, { useState } from 'react';
//temporarily disbale
// import moment from "moment";
// import { CSVLink } from "react-csv";
import ListFilterMenu from '../../shared/list-filter-menu/List-Filter-Menu';
import './cardWrapper.scss';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';
import ExportPageAsPDF from '../../utils/ExportPageAsPDF';

const CardWrapper = (props) => {
  const {
    title,
    children,
    startDate,
    endDate,
    onClickRefreshBtn,
    exportData,
    hotelName,
    excelData,
    isCustom = false,
    showAllForReport = false,
    isRemoveDownload = false,
    showRefreshButton = false,
    showExportButton = false,
    isInformation,
    isInfo = false,
    className = '',
    showLoader = () => {},
    setShowAllForReport = () => {},
  } = props;
  const [filterTargetButton, setFilterTargetButton] = useState(null);

  const handleFilterMenu = (event) => {
    setFilterTargetButton(event.currentTarget);
  };

  const handleFilter = (filterItems, field) => {
    if (field === 'pdf') {
      exportData();
    }
    return true;
  };

  const titleFontSize = title === 'Items' ? 'analytic-subtitle' : 'analytic-title';

  return (
    <div className={`${className} card-wrapper col`} style={{ minHeight: '20rem' }}>
      <div className='analytic-header-wrapper d-flex align-items-center'>
        <div className='col d-flex text-nowrap flex-column justify-content-start'>
          <span className={`${titleFontSize}`}>{title}</span>
          {isInfo && (
            <span className='descriptionText'>
              * Failure data is available from 1st April 2024.
            </span>
          )}
          {/* temporarily disbale
          {!isCustom && (
            <span className="analytic-helper-text ps-4">{`(Showing results from  ${moment(
              startDate
            ).format("Do MMMM YYYY")} to ${moment(endDate).format(
              "Do MMMM YYYY"
            )})`}</span>
          )} */}
        </div>

        <div className='col d-flex justify-content-end align-items-center'>
          {showExportButton && (
            <div>
              {!isRemoveDownload && (
                <>
                  {/* temporarily disbale */}
                  {/* <img
                    title="File Export"
                    className="me-2 analytic-refresh-icon"
                    src="./assets/icons/dashboard/export-icon.svg"
                    alt="completed"
                    onClick={(e) => {
                      handleFilterMenu(e);
                    }}
                  /> */}
                  {!showAllForReport && (
                    <ExportPageAsPDF
                      contentId={title}
                      hotelName={hotelName}
                      fileName={title}
                      startDate={startDate}
                      endDate={endDate}
                      isTableReport={false}
                      showLoader={showLoader}
                      title={title}
                      showAllForReport={showAllForReport}
                      setShowAllForReport={setShowAllForReport}
                    />
                  )}
                  <ListFilterMenu

                  // menu={[
                  //   {
                  //     title: (
                  //       <span>
                  //         <img
                  //           className="pe-3 icon"
                  //           src="/assets/icons/dashboard/pdf.svg"
                  //           alt="icon"
                  //         />
                  //         PDF
                  //       </span>
                  //     ),
                  //     field: "pdf",
                  //     subMenu: [],
                  //   },
                  //   {
                  //     title: (
                  //       <span>
                  //         <CSVLink
                  //           style={{
                  //             color: "#000000",
                  //             textDecoration: "none",
                  //           }}
                  //           filename={`${title.toLowerCase()}.csv`}
                  //           data={excelData ? excelData : []}
                  //         >
                  //           <>
                  //             <img
                  //               className="pe-3 icon"
                  //               src="/assets/icons/dashboard/excel.svg"
                  //               alt="icon"
                  //             />
                  //             Spreadsheet
                  //           </>
                  //         </CSVLink>
                  //       </span>
                  //     ),
                  //     field: "excel",
                  //     subMenu: [],
                  //   },
                  // ]}
                  // targetEl={filterTargetButton}
                  // handleFilterClose={() => setFilterTargetButton(null)}
                  // handleFilter={(items, field) => {
                  //   handleFilter(items, field);
                  // }}
                  />
                </>
              )}
            </div>
          )}

          {showRefreshButton && (
            <div>
              <img
                title='Reload'
                className='mt-1 ms-1 me-4 analytic-refresh-icon'
                src='./assets/icons/dashboard/sync-icon.svg'
                alt='completed'
                onClick={onClickRefreshBtn}
              />
            </div>
          )}
          {!showAllForReport && isInformation && (
            <div className='margin-right-12'>
              <Tooltip title={isInformation} placement='right'>
                <InfoIcon style={{ fontSize: '15px' }} />
              </Tooltip>
            </div>
          )}
        </div>
      </div>
      <div className='analytic-breaker' />
      {children}
    </div>
  );
};

export default CardWrapper;
